export const MUSCLES = [
  "quads",
  "hamstrings",
  "glutes",
  "calves",
  "chest",
  "lats",
  "upper_back",
  "lower_back",
  "shoulders",
  "triceps",
  "biceps",
  "abs",
  "cardio",
] as const;

export const EQUIPMENT = ["machine", "cable", "smith", "dumbbell", "barbell", "bodyweight", "cardio", "other"] as const;
